import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const ChevronLeft = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M29.7682 4.35981C30.1218 4.78409 30.0645 5.41465 29.6402 5.76822L12.562 20L29.6402 34.2318C30.0645 34.5853 30.1218 35.2159 29.7682 35.6402C29.4147 36.0645 28.7841 36.1218 28.3598 35.7682L10.3598 20.7682C10.1318 20.5782 10 20.2968 10 20C10 19.7032 10.1318 19.4218 10.3598 19.2318L28.3598 4.23177C28.7841 3.87821 29.4147 3.93553 29.7682 4.35981Z" 
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default ChevronLeft;
